export const removeParametersFromRoute = () => {
  const index = window.location.href.lastIndexOf('/')
  const url = window.location.href.substring(0, index)
  window.history.replaceState({}, '', url);
}